// removed by extract-text-webpack-plugin
module.exports = {"page-title":"_1uErLFFeOvTp-Y45HTc1F3"};


//////////////////
// WEBPACK FOOTER
// ./src/common/components/PageTitle/styles.scss
// module id = 1173
// module chunks = 1